const filterListModal = {
  text: 'FILTERS',
  clear: 'clean filters'
};

export default filterListModal;
